import { useHotelSlot } from "@b2bportal/core-hotels";
import { useHotelsStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import type { DateRange, Lodging } from "@b2bportal/lodging-api";
import { HotelCard, useHotelCardTracking } from "@tenant/hotels";
import clsx from "clsx";
import defaultStyles from "./HotelListItem.module.scss";

export type HotelListItemProps = {
  hotel: Lodging;
  onHover?: (hotelId: string | undefined) => void;
  dateRange: DateRange;
  rooms?: number;
} & PlatformComponentProps;

export const HotelListItem = ({
  hotel,
  className,
  onHover,
  dateRange,
  rooms,
}: HotelListItemProps) => {
  const styles = useHotelsStyles(
    CoreHotelsComponent.HotelListItem,
    defaultStyles
  );
  const [block, cn] = useModuleBEM(styles, CoreHotelsComponent.HotelListItem, {
    available: hotel.price != null,
  });

  const HotelSlot = useHotelSlot();
  const { ref: containerRef } = useHotelCardTracking({ hotel });

  return (
    <div className={clsx(block, className)} ref={containerRef}>
      <HotelSlot.HotelLink hotel={hotel}>
        <HotelCard
          hotel={hotel}
          onHover={onHover}
          dateRange={dateRange}
          rooms={rooms}
        />
      </HotelSlot.HotelLink>
    </div>
  );
};
